import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DiagnosisModel } from '../DoctorModels/diagnosis.model';
import { EMRService } from '../EMR.service';
import { SurgeryCategoryModel } from '../HistoryModels/surgery_Category.model';
import { SelectionModel } from '@angular/cdk/collections';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DiagnosisMasterComponent } from 'app/masters/diagnosis-master/diagnosis-master.component';
import { CategorymasterComponent } from 'app/masters/categorymaster/categorymaster.component';

@Component({
  selector: 'app-Diagnosis',
  templateUrl: './Diagnosis.component.html',
  styleUrls: ['./Diagnosis.component.scss']
})
export class DiagnosisComponent implements OnInit {
  destroydiag$: Subject<boolean> = new Subject<boolean>();
  private sitetype: any;
  private diagnosisdata: any = [];
  private diagonisisName: string = '';
  private diagonisCode: string = '';
  private diagonisicatid: number = 0;
  private SelecteddiagonsisArray: any = []
  private daigonisCategory_ds = new MatTableDataSource<SurgeryCategoryModel>();
  private selection = new SelectionModel<SurgeryCategoryModel>(true, []);
  private displayedColumns_departments: string[] = ['categoryName'];
  private rowClicked: any;
  stype:any;
  private diagnosis_ds: MatTableDataSource<DiagnosisModel>
  // diagnosis_ds1: MatTableDataSource<DiagnosisModel>
  private displayedColumns_diagnosis: string[] = ['icd', 'diagnosis'];
  // displayedColumns_diagnosis1: string[] = ['icd', 'diagnosis'];
  private disableaddmaster: boolean = true;
  constructor(private dialog: MatDialog, private dashboardService: DashboardService,
    private emrservice: EMRService,
    private dialogRef: MatDialogRef<DiagnosisComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
    this.GetGetDiagnosis(0,0,0);
  }

  ngOnInit() {
    this.rowClicked = -1;
    this.diagnosisdata=[];
    this.SelecteddiagonsisArray=[];
    this.disableaddmaster=true;
    this.diagonisicatid=0;
    this.diagonisCode='';
    this.diagonisisName='';
    //  this.departments_ds.data = this.helplistservice.surgery_departments;
    this.diagnosis_ds = new MatTableDataSource(this.emrservice.diagnosis.slice());
    this.getDiagonisisCategory(0);

    this.sitetype = null;
    this.stype='S';
    //this.GetGetDiagnosisByuserId(this.authService.Loggeduser.userid);

    // this.GetDiagnosisFrequentByUserId(this.authService.Loggeduser.userid)
    // this.GetDiagnosisFrequentByUserId(this.authService.Loggeduser.userid);
  }
  searchType(event) {
    this.stype = event;
  }
  ngOnDestroy() {
   
    this.destroydiag$.next(true);
    this.destroydiag$.unsubscribe();
    this.diagnosisdata=null;
    this.SelecteddiagonsisArray=null;
    this.disableaddmaster=null;
    this.diagonisicatid=null;
    this.diagonisCode=null;
    this.diagonisisName=null;
    this.diagnosis_ds=null;
    this.sitetype=null;
    this.daigonisCategory_ds=null;
    this.displayedColumns_diagnosis=null;
    this.stype=null;
  }
  closedialog() {

    this.dialogRef.close(this.SelecteddiagonsisArray = []);

  }
  eyeTypeChange(event) {
    this.sitetype = event;
  }

  // GetDiagnosisFrequentByUserId(userid) {
  //   this.emrservice.GetDiagnosisFrequentByUserId(userid).subscribe(data => this.sucees_dagonisUserId(data), err => this.err_daigonsis(err));
  // }
  // sucees_dagonisUserId(data) {
  //   if (data.length > 0) {
  //     this.diagnosis_ds1 = new MatTableDataSource(data.slice());
  //   }
  // }
  getDiagonisisCategory(diaid) {

     this.emrservice.GetDiagonisCategory(diaid).pipe(takeUntil(this.destroydiag$)).subscribe(data => this.sucees_dagonis(data), err => this.err_daigonsis(err));
  }

  sucees_dagonis(data) {
    if (data.length > 0) {
      this.daigonisCategory_ds.data = data.filter(item => item.isActive == true);
    }

  }
  GetGetDiagnosis(diagonisiid,searchname,searchtype) {
     this.emrservice.GetGetDiagnosis(diagonisiid,searchname,searchtype).pipe(takeUntil(this.destroydiag$)).subscribe(data => this.sucees_dagonisdata(data), err => this.err_daigonsis(err));
  }
  sucees_dagonisdata(data) {
    this.diagnosisdata = [];
    if (data.length > 0) {
      this.diagnosisdata = data.filter(item => item.isActive == true);
      this.diagnosis_ds = new MatTableDataSource(this.diagnosisdata.slice());
    }
  }
  err_daigonsis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  selectDaigonsis(fK_DgCategoryId) {
    if (fK_DgCategoryId > 0) {
      this.diagonisicatid = fK_DgCategoryId;
      this.diagnosis_ds.data = this.diagnosisdata.filter(item => item.fK_DgCategoryId == fK_DgCategoryId);
    } else {
      this.diagnosis_ds.data = this.diagnosisdata;
    }

  }
  // applyFilter_surgeries(filterValue: string) {
  //   this.diagnosis_ds.filter = filterValue.trim().toLowerCase();
  // }
  filtersurgerydata(event) {
   
    if (event.key === 'Enter') {
      event.preventDefault();
      if(event.target.value.length >=3 ){
        this.emrservice.GetGetDiagnosis(0,event.target.value,this.stype).pipe(takeUntil(this.destroydiag$)).subscribe((item: any) => {
          this.diagnosis_ds.data = item.filter(item=>item.isActive==true);
        },err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      }
    }else{
    const finddata = this.filerdata(this.diagnosisdata.slice(), event.target.value);
    if (finddata.length > 0) {
      this.diagnosis_ds.data = finddata;
    } else {
      this.diagnosis_ds.data =[];
      if(event.target.value.length >=3 ){
      if (event.target.value != null && event.target.value != '') {
        var pdata = event.target.value
      } else {
        pdata = 0;
      }
      this.emrservice.GetGetDiagnosis(0,pdata,this.stype).pipe(takeUntil(this.destroydiag$)).subscribe((item: any) => {
        this.diagnosis_ds.data = item.filter(item=>item.isActive==true);
      },err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    }
    }
  }
  }
  filerdata(items: any[], searchText: string) {
    if(this.stype=='S'){
      let smallchar=searchText?searchText.toLowerCase():'';
      return items ? items.filter(item => item.diagnosisName?.toLowerCase().indexOf(smallchar) === 0 || item.icdCode?.toLowerCase().indexOf(smallchar) === 0):[];
    }else{
      return items ? items.filter(item => (item.diagnosisName).search(new RegExp(searchText, 'i')) > -1) : [];
      
    }
  }
  changeTableRowColor(idx: any) {
    if (this.rowClicked === idx) {

      this.rowClicked = -1;
    }
    else {

      this.rowClicked = idx;
    }

  }

  onicdcodeChange(e: any, index: number) {
    if (e != null) {
      this.SelecteddiagonsisArray[index].icdcode = e;
    }
  }

  ondiNameChange(e: any, index: number) {
    if (e != null) {
      this.SelecteddiagonsisArray[index].diagnosisName = e;
    }
  }
  onsiteChange(e: any, index: number) {
    if (e != null) {
      this.SelecteddiagonsisArray[index].site = e;
    }
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */

  selectRow(row) {
    if(this.sitetype){
    row.site = this.sitetype;
    this.selection.toggle(row);
    var checkarraydata = this.SelecteddiagonsisArray.filter(item => item.diagnosisName.toLowerCase() == row.diagnosisName.toLowerCase());
    if (checkarraydata.length > 0) {
      this.SelecteddiagonsisArray = this.SelecteddiagonsisArray.filter(item => item.pk_DiagnosisId != row.pk_DiagnosisId);
    } else {
      this.SelecteddiagonsisArray.push(row);
    }

    this.SelecteddiagonsisArray = this.SelecteddiagonsisArray.reduce((unique, o) => {
      if (!unique.some(obj => obj.diagnosisName === o.diagnosisName && obj.pk_DiagnosisId === o.pk_DiagnosisId)) {
        unique.push(o);
      }
      return unique;
    }, []);
   
    //this.diagnosis_ds2.data= this.SelecteddiagonsisArray;
  }else{
    this.dashboardService.openSnackBar("Please select eye.", "OK");
  }
  }

  removeRow(x) {

    // this.SelecteddiagonsisArray.splice(x,1);
    //  this.diagnosis_ds2.data=this.SelecteddiagonsisArray;
    const index: number = this.SelecteddiagonsisArray.indexOf(x);
    if (index !== -1) {
      this.SelecteddiagonsisArray.splice(index, 1);
      this.selection.toggle(x);
    }
  }

  transferData() {
    const checkdaigonosisid = this.SelecteddiagonsisArray.filter(item => item.pk_DiagnosisId == 0);
    if (checkdaigonosisid.length > 0) {
      this.dashboardService.openSnackBar("Please Update First in Master", "OK");
    } else {
      this.dialogRef.close(this.SelecteddiagonsisArray);
      this.diagonisisName = ''
      this.diagonisCode = ''
      this.diagonisicatid = 0;
      this.disableaddmaster = true;
    }

  }

  AddDaigonsis() {
    if (this.diagonisicatid > 0) {
      if (this.diagonisisName != '') {
        const checkdaignosisName = this.diagnosisdata.filter(item => item.diagnosisName.toLowerCase() == this.diagonisisName.toLowerCase());
        if (checkdaignosisName.length == 0) {
          const checkdata = this.SelecteddiagonsisArray.filter(item => item.diagnosisName.toLowerCase() == this.diagonisisName.toLowerCase());
          if (checkdata.length == 0) {
            let payload = {
              "diagnosisName": this.diagonisisName,
              "fK_DgCategoryId": this.diagonisicatid ? this.diagonisicatid : 0,
              "icdCode": this.diagonisCode,
              "isActive": true,
              "isHeading": true,
              "pk_DiagnosisId": 0,
              "isSelect": null,
              "pk_SynchId": null
            }
            this.diagonisisName = ''
            this.diagonisCode = ''
            this.disableaddmaster = false;
            this.selectRow(payload);
          } else {
            this.dashboardService.openSnackBar("Diagnosis Name is already Existed", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Diagnosis Name is already Existed", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Please Enter Diagnosis Name", "OK");
      }

    } else {
      this.dashboardService.openSnackBar("please Select Category", "OK");
    }

  }

  AddMaster() {

    if (this.diagonisicatid > 0) {
      const diagnosisid = this.SelecteddiagonsisArray.filter(item => item.pk_DiagnosisId == 0);
      if (diagnosisid.length > 0) {
        diagnosisid.forEach((item, index) => {
          let payload = {
            "Pk_DiagnosisId": 0,
            "FK_DgCategoryId": item.fK_DgCategoryId,
            "ICDCode": item.icdCode,
            "DiagnosisName": item.diagnosisName,
            "IsHeading": true,
            "IsActive": 1,
            "IsHidden": 0
          }
          this.emrservice.SaveDaigonsisData(payload).pipe(takeUntil(this.destroydiag$)).subscribe((x: any) => {
            let dainsisid = x['id'];
            let diagnosisfilter;
            diagnosisfilter = diagnosisid.filter(item => item.diagnosisName == item.diagnosisName);
            diagnosisid[index].pk_DiagnosisId = dainsisid;
            this.diagonisisName = ''
            this.diagonisCode = ''
            this.diagonisicatid = 0;
            this.GetGetDiagnosis(0,0,0);
            this.disableaddmaster = true;
            this.diagnosis_ds = new MatTableDataSource(this.SelecteddiagonsisArray.slice());
            this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        });

      } else {
        this.dashboardService.openSnackBar("New Record Not Available", "OK");
      }

    } else {
      this.dashboardService.openSnackBar("Please Select Category", "OK");
    }
  }

  openAddCategory(): void {
    const dialogRef = this.dialog.open(CategorymasterComponent, {
      panelClass: 'custom-dialog',
      maxWidth: '50vw',
      height: '50%',
      width: '50%',
      data: {
        isheader: true,
        disableClose: true
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroydiag$)).subscribe(result => {

      this.getDiagonisisCategory(0);
    });
  }

  openDiagnosis(){
    const dialogRef = this.dialog.open(DiagnosisMasterComponent, {
      panelClass: 'custom-dialog',
       maxWidth: '50vw',
       height: '50%',
      width: '50%',
      disableClose: true,
      data: {
        isheader: true,
        disableClose: true
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroydiag$)).subscribe(result => {

    });
  }
  cancle(){
    document.getElementById("diagnosisMaster").style.display = "none";
  }
}
